import React from 'react'
import '../stylesheets/menuButton.sass'

const MenuButton = ({isBlack}) => {

	let firstx1 = isBlack ? "5" : "0"
	let firstx2 = isBlack ? "50" : "45"
	let secondx1 = isBlack ? "0" : "5"
	let secondx2 = isBlack ? "45" : "50"

		return (
			<div className="menuButton">
				<h1>Menu</h1>
				<svg className={"menuIcon" + (isBlack ? " black" : "")} xmlns="http://www.w3.org/2000/svg" width="50" height="31" >
	  				<g strokeWidth="1">
						<line x1={firstx1} x2={firstx2} transform="translate(0 0.5)"/>
						<line x1={secondx1} x2={secondx2} transform="translate(0 10.5)"/>
			    		<line x1={firstx1} x2={firstx2} transform="translate(0 20.5)"/>
			    		<line x1={secondx1} x2={secondx2} transform="translate(0 30.5)"/>
			  		</g>
				</svg>
			</div>
		)
}

export default MenuButton